/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/Assign/Content/SaveAction",
  isSubmitting
  
}) {
let txCategoryInsuredIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_category_insured',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 marginLeft={dtSpaceXs}
 type="primary"
 onClick={onClick}
 data="tx_category_insured"
 disabled={txCategoryInsuredIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}